import React, {useCallback, useEffect, useRef, useState} from "react";
import {apiURL} from "../../api";
import lodash from "lodash";
import {CircularProgress} from "@material-ui/core";
import PagePlaceholder from "./PagePlaceholder";
import {computeStyleFor, getColorByIndex} from "./utils";

function PageImage(props) {
    let {page, scale, data, signerMode, providePage, provideElement} = props;
    //let [dimensions, setDimensions] = useState({width: 0, height: 0});

    let [loading, setLoading] = useState(true);
    let [error, setError] = useState(false);
    let [loaded, setLoaded] = useState(false);
    let [visible, setVisible] = useState(false);
    let minH = 300;
    let mw = Math.floor(props.mainWidth);
    let [src, setSrc] = useState(props.mainWidth ? apiURL('serve/' + page.image + "?completed=" + page.detail.completed + "&width=" + (mw * window.devicePixelRatio)) : undefined);
    let ref = useRef(null);

    useEffect(() => {
        if (ref) {
            let [pp, setProvidePage] = providePage;
            pp['page-' + page.detail.id] = {
                element: ref.current,
                page: true,
                setVisible: setVisible
            };
            setProvidePage({
                ...pp
            });
        }
    }, [ref, ref ? ref.current : null]);


    let dimensions = {width: 0, height: 0};
    if (page.detail.page_height) {
        let factor = mw / page.detail.page_width;
        minH = Math.floor(page.detail.page_height * factor);
        dimensions.height = minH;
        dimensions.width = Math.floor(page.detail.page_width * factor);
    }
    let onLoad = (event) => {
        setLoading(false);
        setLoaded(true);
    };

    let onError = () => {
        setLoading(false);
        setError(true);
    };

    const throttled = useCallback(lodash.throttle((newMainWidth) => {
        if (!page.detail.completed) {
            return;
        }

        setSrc(newMainWidth ? apiURL('serve/' + page.image + "?completed=" + page.detail.completed + "&width=" + (newMainWidth * window.devicePixelRatio)) : undefined);
    }, 1000, {leading: false, trailing: true}), []);


    useEffect(() => {
        throttled(mw);
    }, [props.mainWidth, mw, scale, throttled]);

    let loader = loading ? <div className={'circular-loader-over'}><CircularProgress size={100}/></div> : null;
    let errorDisplay = error && !loaded ? <div className={'circular-loader-over'} style={{textAlign: 'center', color: '#999'}}>Failed to load page</div> : null;


    let imageHtml = visible || loaded ? <img onLoad={onLoad}
                                             onError={onError}
                                             style={{width: '100%'}}
                                             alt={data.document.name}
                                             src={src}/> : null;

    let declined = false;
    for (let sg of data.signers) {
        if (sg.declined) {
            declined = true;
        }
    }

    return <div ref={ref} style={{minHeight: minH}} className={'page-image'}>
        {loader}
        {errorDisplay}
        {imageHtml}
        {page.placeholders ? page.placeholders.map((placeholder, index) => {

            let sindex = lodash.find(data.signers, {
                id: placeholder.signer_id
            });

            let computed = computeStyleFor(page, placeholder, dimensions);

            if (!declined && sindex && sindex.unique_id === props.signerID && (!placeholder.signed)) {
                computed.backgroundColor = getColorByIndex(data.signers.indexOf(sindex));
            } else {
                computed.backgroundColor = "transparent";

            }
            computed.position = "absolute";
            computed.display = "block";
            computed.textAlign = "left";
            computed.visibility = !loaded ? 'hidden' : undefined;

            return <PagePlaceholder key={placeholder.id}
                                    page={page}
                                    scale={scale}
                                    loaded={loaded}
                                    pageRef={ref}
                                    setVisible={setVisible}
                                    placeholder={placeholder}
                                    openSignaturePad={props.openSignaturePad}
                                    canSign={!declined && props.signerID && sindex && sindex.unique_id === props.signerID && (!sindex.signed && !sindex.declined)}
                                    signerMode={signerMode}
                                    computed={computed}
                                    provideElement={props.provideElement}/>;
        }) : null}
    </div>;
}

export default PageImage;